import { queryOptions } from '@tanstack/react-query';

import { apiEntityFetch } from '..';
import { GetEntityPublicRes, GetSingleEntityRes, VersionOption } from './types';

export const ENTITY_QUERY_KEYS = {
  entities: 'entity-queries',
  entityPublic: 'entity-public',
  entityMembershipsByUserId: 'entityMembershipsByUserId',
};

///////////////////////////////////////////////

export const _getSingleEntityOptions = (id?: string | null, version?: VersionOption) => {
  return queryOptions({
    enabled: !!id,
    queryKey: [ENTITY_QUERY_KEYS.entities, id, version ?? 'default'],
    queryFn: () =>
      apiEntityFetch<GetSingleEntityRes>(
        version ? `/entities/${id}?version=${version}` : `/entities/${id}`,
      ),
  });
};

export const _getEntityPublic = (id?: string) => {
  return queryOptions({
    enabled: !!id,
    queryKey: [ENTITY_QUERY_KEYS.entityPublic, id],
    queryFn: () => apiEntityFetch<GetEntityPublicRes>(`/entities/${id}/public`),
    refetchOnMount: true,
    retry: 1,
  });
};

//////////////////////////////////////////////

export type EntityMembershipsRes = {
  entityId: string;
  entityName: string;
  isDirector: boolean;
  entityRole: string;
  userTitle: string;
  activeSince: string;
};

export const _getEntityMembershipsByUserId = (id: string) => {
  return queryOptions({
    queryKey: [ENTITY_QUERY_KEYS.entityMembershipsByUserId, id],
    queryFn: () =>
      apiEntityFetch<EntityMembershipsRes[]>(`/entity-memberships/users/${id}/memberships`),
  });
};
